<template>
  <div>
    <b-modal
      id="IsshowVendor"
      class="cust-app-modal popupwidth"
      hide-footer
      hide-header
    >
      <AddVendorPopup />
    </b-modal>
    <b-modal
      id="IsshowVendorDetails"
      class="cust-app-modal popupwidth"
      hide-footer
      hide-header
    >
      <div class="relative">
        <div class="absolute top-0 right-4">
          <feather-icon icon="XIcon" @click="handleClose" />
        </div>
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
            <div class="w-full pt-5">
              <p class="fsize15">GST No.<span class="clr-red">*</span></p>
              <base-input
                v-model="GST_No"
                placeholder="Enter GST number"
                name="GST_No"
                class="cust-form-border"
                :rules="{ required: true }"
              ></base-input>
            </div>
            <div class="w-full pt-3">
              <p class="fsize15">Commision <span class="clr-red">*</span></p>
              <base-input
                v-model="Commission"
                placeholder="Enter Commision"
                name="Commision"
                class="cust-form-border"
                :rules="{ required: true }"
              ></base-input>
            </div>
            <div class="w-full pt-3">
              <p class="fsize15">Account No <span class="clr-red">*</span></p>
              <base-input
                v-model="accountNumber"
                placeholder="Enter account number"
                name="Account Number"
                class="cust-form-border"
                :rules="{ required: true, regex: '^[0-9]{9,18}$' }"
              ></base-input>
            </div>
            <div class="w-full pt-3">
              <p class="fsize15">IFSC Code <span class="clr-red">*</span></p>
              <base-input
                v-model="IFSCCode"
                placeholder="Enter IFSC code"
                name="IFSC Code"
                class="cust-form-border"
                :rules="{ required: true, regex: '^[A-Z]{4}0[A-Z0-9]{6}$' }"
              ></base-input>
            </div>
            <div class="pt-5 flex justify-center">
              <button
                class="bg-primary text-white px-8 py-2 rounded"
                type="submit"
              >
                Submit
              </button>
            </div>
          </b-form>
        </validation-observer>
      </div>
      <!-- <ViewVendorDetailpopup :vendorData="vendorData" /> -->
    </b-modal>
    <b-card class="">
      <div class="flex justify-between">
        <h2 class="text-2xl font-semibold">Vendor Details</h2>
        <div>
          <base-button
            v-b-modal.IsshowVendor
            type="primary"
            outline
            class="px-2 py-2 mx-1 flex items-center"
          >
            <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>
            Add Vendor
          </base-button>
        </div>
      </div>
      <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          v-model="search"
          @input="init"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="this.getAllVendor.result"
      >
        <!-- <el-table-column label="Sr no." prop="srno" min-width="80px" >
        </el-table-column> -->

        <el-table-column
          label="Vendor Name"
          prop="vname"
          min-width="140px"
          v-slot="{ row }"
        >
          {{ row.fullname }}
        </el-table-column>
        <el-table-column
          label="Email"
          prop="email"
          min-width="180px"
          v-slot="{ row }"
        >
          {{ row.userId[0].email }}
        </el-table-column>
        <el-table-column
          label="Contact No."
          prop="mobile"
          min-width="160px"
          v-slot="{ row }"
        >
          {{ row.userId[0].mobile }}
        </el-table-column>

        <el-table-column
          label="Brand Name"
          min-width="160px"
          prop="bname"
          v-slot="{ row }"
        >
          {{ row.brandId[0].name }}
        </el-table-column>
        <el-table-column
          label="Details"
          min-width="160px"
          prop="details"
          v-slot="{ row }"
        >
          <template>
            <b-media no-body class="align-items-center cursor-pointer">
              <b-media-body>
                <!-- v-b-modal.IsshowVendorDetails -->
                <span
                  @click="addDetails(row)"
                  class="font-medium underline name mb-0 text-sm"
                  >Add Details</span
                >
              </b-media-body>
            </b-media>
          </template>
        </el-table-column>
        <el-table-column
          label="Action"
          min-width="160px"
          prop="bname"
          v-slot="{ row }"
        >
          <!-- <base-button
            type="primary"
            class="px-6 py-1 mx-1 flex items-center h-10 ml-4"
            v-if="row.isActive"
            @click="handleBlock(row)"
          >
         
            Block
          </base-button>
          <base-button
            type="primary"
            class="px-6 py-1 mx-1 flex items-center h-10 ml-4"
            v-if="!row.isActive"
            disabled
          >
            Blocked
          </base-button> -->
          <base-button
            type="primary"
            class="px-6 py-1 mx-1 flex items-center h-10 ml-4"
            @click="handleBlock(row)"
          >
            {{ Number(row.isBlocked) === 1 ? "Unblock" : "Block" }}
          </base-button>
        </el-table-column>
      </el-table>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          @change="handlePageChange"
          :per-page="perPage"
          :total="total_row"
        ></base-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
// import projects from "../../../layouts/components/projects";
import { mapState } from "vuex";
import AddVendorPopup from "./components/AddVendorPopup.vue";
import ViewVendorDetailpopup from "./components/ViewVendorDetailpopup.vue";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    AddVendorPopup,
    ViewVendorDetailpopup,
  },
  data() {
    return {
      tableData: [
        {
          srno: "1",
          vname: "tryhfhh",
          email: "xyz@gmail.com",
          mobile: "5555555555",
          bname: "gasgdgdsg",
          details: "",
          vendorData: {},
          search: "",
        },
      ],
      bankName: "",
      accountNumber: "",
      IFSCCode: "",
      GST_No: "",
      Commission: "",
      currentPage: 1,
      total_row: 1,
      perPage: 5,
    };
  },
  methods: {
    async init() {
      // console.log(this.get_upcomingbooking);
      let payload = {
        limit: 5,
        offset: (this.currentPage - 1) * 5,
        search: this.search,
      };

      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch(
          "affiliate/getVendorByAdmin",
          payload
        );
        this.total_row = this.getAllVendor.totalCount;
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async handleStatus(status, id) {
      let payload = {
        _id: id,
        status: "Completed",
      };
      try {
        await this.$store.dispatch("respitecare/editbooking", payload);
      } catch (error) {}
    },
    addDetails(data) {
      this.vendorData = data;
      if (data.GST_No) {
        this.GST_No = data.GST_No;
      }
      if (data.bank) {
        this.bankName = data.bankName;
      }
      if (data.accountNumber) {
        this.accountNumber = data.accountNumber;
      }
      if (data.IFSCCode) {
        this.IFSCCode = data.IFSCCode;
      }
      if (data.Commission) {
        this.Commission = data.Commission;
      }
      this.$bvModal.show("IsshowVendorDetails");
    },
    async handlePageChange(value) {
      this.currentPage = value;
      try {
        this.init();
      } catch (error) {}
    },
    reset() {
      this.GST_No = "";
      this.bankName = "";
      this.accountNumber = "";
      this.IFSCCode = "";
      this.Commission = "";
      this.vendorData = {};
    },
    handleClose() {
      this.reset();
      this.$bvModal.hide("IsshowVendorDetails");
    },
    async onSubmit() {
      let payload = {
        bankName: this.bankName,
        accountNumber: this.accountNumber,
        IFSCCode: this.IFSCCode,
        GST_No: this.GST_No,
        Commission: this.Commission,
        vendorId: this.vendorData._id,
      };
      try {
        let data = await this.$store.dispatch(
          "affiliate/updateVendor",
          payload
        );
        // console.log(data);
        this.handleClose();
        this.reset();
        this.init();
      } catch (error) {}
    },
    async handleBlock(row) {
      // const isBlocking = row.isBlocked !== 1;
      const currentStatus = Number(row.isBlocked);
      const isBlocking = currentStatus !== 1;

      const payload = {
        isBlocked: isBlocking ? 1 : 0,
        vendorId: row._id,
      };
      // let payload = {
      //   isBlocked: 1,
      //   vendorId: val._id,
      // };
      try {
        let loader = this.$loading();
        let data = await this.$store.dispatch(
          "affiliate/updateVendor",
          payload
        );
        if (data.code == 200) {
          this.$set(row, "isBlocked", payload.isBlocked);
          this.$swal.fire({
            text: "Vendor  status Updated!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });

          // await this.init();
        }
        loader.close();
      } catch (error) {
        this.$loading().close();
      }
    },
  },
  computed: {
    ...mapState("affiliate", {
      getAllVendor: "getAllVendor",
    }),
  },
  mounted() {
    this.init();
  },
};
</script>
